import { FinishLine } from './FinishLine'
import { TrackLocation } from './TrackLocation'
import { TrackMetadata, TrackType, SurfaceType } from './TrackMetadata'

export class Track {
  readonly id: string
  readonly name: string
  readonly location: TrackLocation
  readonly lengthMeters?: number
  readonly turns?: number
  readonly direction?: 'clockwise' | 'counterclockwise'
  readonly type: TrackType
  readonly surfaces: SurfaceType[]
  readonly notes?: string
  readonly finishLine?: FinishLine
  readonly isUserSuggested: boolean

  constructor(
    metadata: TrackMetadata,
    finishLine?: FinishLine,
    isUserSuggested: boolean = false
  ) {
    this.id = metadata.trackId
    this.name = metadata.trackName
    this.location = metadata.location
    this.lengthMeters = metadata.lengthMeters
    this.turns = metadata.turns
    this.direction = metadata.direction
    this.type = metadata.type
    this.surfaces = metadata.surfaces || []
    this.notes = metadata.notes
    this.finishLine = finishLine
    this.isUserSuggested = isUserSuggested
  }

  hasFinishLine(): boolean {
    return this.finishLine !== undefined
  }

  getDisplayName(): string {
    if (this.location.city) {
      return `${this.name} - ${this.location.city}, ${this.location.country}`
    }
    return `${this.name} - ${this.location.country}`
  }

  isConfigured(): boolean {
    return this.hasFinishLine() && this.lengthMeters !== undefined
  }

  isUnknown(): boolean {
    return this.type === TrackType.Unknown
  }
}
